"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    background-color: ", ";\n    padding: ", "em 0 0;\n\n    ", ";\n"], ["\n    width: 100%;\n    background-color: ", ";\n    padding: ", "em 0 0;\n\n    ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n            bottom: 0;\n            position: fixed;\n        "], ["\n            bottom: 0;\n            position: fixed;\n        "]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _functions = require("../functions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StickyFooter = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.footer.background;
}, function (props) {
    return props.theme.footer.padding;
}, function (props) {
    return props.fixed && (0, _styledComponents.css)(_templateObject2);
});

var Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer(props) {
        _classCallCheck(this, Footer);

        var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

        _this.state = {
            fixed: false
        };
        return _this;
    }

    _createClass(Footer, [{
        key: "onElementHeightChange",
        value: function onElementHeightChange(elm, callback) {
            var lastHeight = elm.clientHeight,
                newHeight;
            (function run() {
                newHeight = elm.clientHeight;
                if (lastHeight != newHeight) callback();
                lastHeight = newHeight;

                if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer);

                elm.onElementHeightChangeTimer = setTimeout(run, 200);
            })();
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            var _this2 = this;

            if ((0, _functions.isBrowser)()) {
                this.isFixed();
                // detect window change
                this.onElementHeightChange(document.body, function () {
                    _this2.isFixed();
                });
            }
        }
    }, {
        key: "isFixed",
        value: function isFixed() {
            this.setState({
                fixed: Boolean(document.body.offsetHeight < window.innerHeight)
            });
        }
    }, {
        key: "render",
        value: function render() {
            return _react2.default.createElement(
                StickyFooter,
                { fixed: this.state.fixed },
                this.props.children
            );
        }
    }]);

    return Footer;
}(_react.Component);

exports.default = Footer;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/footer.js
// module id = 996
// module chunks = 95715928098905 168707334958949